import {call, put} from "redux-saga/effects";
import {history} from "../store";
import {
    receiveShipmentData,
    noResultsShipmentData,
    receiveNotFoundShipmentIds,
    setRequestedShipmentDataFlag,
    errorRetrievingShipmentsData
} from "../actions/shipmentDataActions";
import {fetchShipmentData} from "../api/shipmentDataApi";


// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export default function* getShipmentData(action) {
    try {
        // do api call
        const data = []
        for (let item of action.payload) {
            let result = yield call(fetchShipmentData, item);
            if (!result.message) {
                data.push(result);
            }
        }
        const path = stripEndSlash(action.option.nextUrl);
        let trackingResultsPath = `${path}/tracking-results`;
        let trackingDetailsPath = `${path}/tracking-details`;

        if (data.length === 0) {
            yield put(noResultsShipmentData());
        } else {
            const notFoundIds = getNotFoundShipmentIds(action.payload, data);
            yield put(receiveShipmentData(data));
            yield put(receiveNotFoundShipmentIds(notFoundIds));
            yield put(setRequestedShipmentDataFlag());
            const urlToPush = getUrl(action.payload);
            if (data.length > 1) {
                history.push({
                    pathname: trackingResultsPath,
                    search: urlToPush
                });
            } else {
                history.push({
                    pathname: trackingDetailsPath,
                    search: 'trackingId=' + data[0].awbPrefix + '-' + data[0].awbNumber
                });
            }
        }

    } catch (e) {
        console.log("ERROR");
        yield put(errorRetrievingShipmentsData(e.message));
    }
}

function stripEndSlash(path) {
    return path.replace(/\/$/, '');
}

function getUrl(initialRequest) {
    let querystring = '?trackingInfo=';
    initialRequest.forEach((request) => {
        querystring += request.airlineCode + '-' + request.trackingNumber + ',';

    });
    if (querystring.length > 1) {
        querystring = querystring.slice(0, querystring.length - 1);
    }
    return (querystring);
}

function getNotFoundShipmentIds(initialRequest, result) {
    let notFoundIds = [];
    // eslint-disable-next-line
    initialRequest.map(request => {
        const trackingResultForRequest = result.filter(e => e.awbNumber === request.trackingNumber);
        if (trackingResultForRequest.length === 0) {
            const fullTrackingId = request.airlineCode + '-' + request.trackingNumber;
            notFoundIds.push(fullTrackingId);
        }
    });
    return notFoundIds;
}



// WEBPACK FOOTER //
// ./src/sagas/shipmentSaga.js